<script>
import CustomInput from "@/components/CustomInput.vue";
import {AppApi} from "@/api/AppApi";

export default {
  name: "UserBusinessInformation",
  components: {CustomInput},
  data()
  {
    return{
      cats_options : [],
      brand_options:[],
    }
  },
  watch : {
    'user.guild_ids':{
      handler(new_ids)
      {
        //باید دیدکه این صنف جدید انتخاب شده آیا اون برند ها و دسته بندی ها رو داره
       this.checkBrandAndCatsHaveGuild();
      },deep : true,important : true
}
  },
  props : ['user','user_id','states','cities'],
  methods : {
    async fetchProductBrands(text,loading)
    {
      loading(true);
      if (text && text.length)
      {
        const result = await AppApi.getProductBrandForSelectAjax(text,this.user.guild_ids);
        if (result)
        {
          this.brand_options = result.brands;
        }
        else
          this.brand_options = [];
      }
      loading(false);
    },
    async fetchProductCategories(text,loading)
    {
      loading(true);
      if (text && text.length)
      {
        const result = await AppApi.getProductCategoriesForSelectAjax(text,this.user.guild_ids);
        if (result)
        {
          this.cats_options = result.categories;
        }
        else
          this.cats_options = [];
      }
      loading(false);
    },
    checkBrandAndCatsHaveGuild()
    {
      const guild_ids = this.user.guild_ids;
      if (guild_ids && guild_ids.length)
      {
        const brand_options = this.user.product_brand_ids;
        const cats_options = this.user.product_category_ids;
        const new_brands = [];
        const new_cats = [];
        for (let i = 0;i<brand_options.length;i++)
        {
          const b_guild_ids = brand_options[i].guild_ids;
          //باید دیدکه اگر توی برند توی صنف هست اضافه بشه
          for (let j = 0;j<guild_ids.length;j++)
          {
            for (let k = 0;k<b_guild_ids.length;k++)
            {
              if (b_guild_ids[k] === guild_ids[j]._id)
              {
                console.log('found')
                new_brands.push(brand_options[i]);
                break;
              }
            }
          }
        }
        this.user.product_brand_ids = new_brands;
        for (let i = 0;i<cats_options.length;i++)
        {
          const cat_guild_id = cats_options[i].guild_id;
          for (let j= 0;j<guild_ids.length;j++)
          {
            if (guild_ids[j]._id === cat_guild_id)
            {
              new_cats.push(cats_options[i]);
              break;
            }
          }
        }
        this.user.product_category_ids = new_cats;
      }
      else
      {
        this.user.product_brand_ids = [];
        this.user.product_category_ids = [];
      }
      this.cats_options = [];
      this.brand_options = [];
    }
  }
}
</script>

<template>
  <div class="row">
    <div :class="(user_id?'col-12':'col-12 col-md-4')">
      <CustomInput type="text" v-model="user.title" name="title" label="نام تجاری" placeholder="نام تجاری..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" v-model="user.shop_telephone" name="shop_telephone" label="تلفن ثابت" placeholder="تلفن ثابت..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" v-model="user.shop_telephone2" name="shop_telephone2" label="تلفن ثابت2" placeholder="تلفن ثابت..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" v-model="user.shop_telephone3" name="shop_telephone3" label="تلفن ثابت3" placeholder="تلفن ثابت..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" name="shop_phone" v-model="user.shop_phone" label="تلفن همراه" placeholder="تلفن همراه..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="select" v-model="user.state_id"
                   :not-select-append-to-body="(!!user_id)"
                   name="state_id" select-label="title"
                   reduce_select="_id" :select-options="states" label="استان"
                   placeholder="استان را انتخاب کنید..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="select" v-model="user.city_id" select-label="title" reduce_select="_id"
                   :select-options="cities"
                   :not-select-append-to-body="(!!user_id)"
                   name="city_id" label="شهر" placeholder="شهر را انتخاب کنید..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="textarea" v-model="user.shop_address" name="shop_address" label="آدرس" placeholder="آدرس..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="textarea" v-model="user.shop_description" name="shop_description" label="درباره فروشگاه" placeholder="درباره فروشگاه..."></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" placeholder="ساعات کاری" name="work_hours" v-model="user.work_hours" label="ساعات کاری"></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" placeholder="روزهای کاری" name="work_days" v-model="user.work_days" label="روزهای کاری"></CustomInput>
    </div>
    <div class="col-12 col-md-4">
      <CustomInput type="text" placeholder="معرفی کوتاه" name="short_content" v-model="user.short_content" label="معرفی کوتاه"></CustomInput>
    </div>
    <div class="col-12 mb-2" v-if="!user.guild_ids || !user.guild_ids.length">
      <div class="form-control">
        برای انتخاب دسته بندی ها باید صنف کاربر مشخص باشد
      </div>
    </div>
    <div v-else class="col-12 mb-2">
      <CustomInput placeholder="دسته بندی محصولات" label="دسته بندی محصولات" type="select"
                   name="product_category_ids" reduce_select="_id" select-label="title" :select_multiple="true" :select-options="cats_options" v-model="user.product_category_ids"
                   :fetch-options="fetchProductCategories"></CustomInput>
    </div>
    <div class="col-12 mb-2" v-if="!user.guild_ids || !user.guild_ids.length">
      <div class="form-control">
        برای انتخاب برندهای محصول باید صنف کاربر مشخص باشد
      </div>
    </div>
    <div v-else class="col-12 mb-2">
      <CustomInput placeholder="برندهای محصولات" label="برندهای محصولات" type="select"
                   name="product_brand_ids[]" select-label="title" reduce_select="_id" :select_multiple="true" :select-options="brand_options" v-model="user.product_brand_ids"
                   :fetch-options="fetchProductBrands"></CustomInput>
    </div>
  </div>
</template>

<style scoped>

</style>